export default "__VITE_ASSET__CKwIGIO9__"